function PISRoutesController(stateService, toasterService, userService, $state) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.editMode = false;
    ctrl.route = {};
    let selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.workspaceId = selectedWorkspace.id;
    ctrl.isLocked = selectedWorkspace.deployable;
    if (!ctrl.workspaceId) $state.go('pis.workspaces');
    ctrl.dataLoading = true;
    stateService.getRunsAndRoutes(ctrl.workspaceId).then(data => {
      ctrl.routes = data.routes;
      ctrl.dataLoading = false;
    });
    ctrl.modalOptions = {
      name: 'route',
      fields: [
        { name: 'Name', key: 'name', type: 'row' },
        { name: 'Description', key: 'description', type: 'row' },
        { name: 'Stations', key: 'stations', type: 'list', listKey: 'name' }
      ],
      deleteCheck: false,
    };
    ctrl.hasCommit = userService.hasCommitPIS();
    ctrl.hasEdit = userService.hasEditPIS();
  };

  ctrl.setEditMode = () => {
    ctrl.editMode = true;
  };

  ctrl.goBackToList = () => {
      ctrl.editMode = false;
      ctrl.selection = null;
      stateService.getRunsAndRoutes(ctrl.workspaceId).then(data => ctrl.routes = data.routes);
  };

  ctrl.onDelete = event => {
    stateService.deleteRoute(ctrl.workspaceId, event.itemId).then(
      response => {
        stateService.getRunsAndRoutes(ctrl.workspaceId).then(data => ctrl.routes = data.routes);
        toasterService.success('toaster.pis-event', 'toaster.pis-delete-route-successful');
      },
      err => {
        toasterService.error('toaster.pis-event', 'toaster.pis-delete-route-failure');
        console.log(err);
      }
    );
  };

  ctrl.onFormSubmit = event => {
    ctrl.editMode = event.mode;
    stateService.getRunsAndRoutes(ctrl.workspaceId).then(data => ctrl.routes = data.routes);
    ctrl.selection = null;
  };

  ctrl.onToggleEdit = event => {
    ctrl.editMode = event.editMode;
    ctrl.selection = event.item;
  };
}

angular
  .module('pis-tool.module')
  .controller('PISRoutesController', PISRoutesController);
